export const FONT_FAMILY_MAIN = "'Muli', 'Trebuchet MS', Tahoma, helvetica, arial, sans-serif";
export const BLUE_GRAY = '#9aa1a9';
export const MAIN_DARK = '#354354';
export const TEXT_COLOR = MAIN_DARK;
export const WHITE = '#ffffff';
export const LIGHT_PINK = '#fee7e9';
export const WATERMELON = '#f74656';
export const RAVEN = '#68727f';
export const COBALT = '#0153b4';
export const MAIN_BLUE = '#4a90e2';
export const ZIRCON = '#d7dadc';
export const SILVER = '#ccd0d4';
export const PALE_GRAY = '#eef1f6';
export const PALE_GRAY_TWO = '#fafafb';
export const PALE_CORNFLOWER_BLUE = '#c8ddf6';
export const GRAY_CHATEAU = '#979ea7';
export const SOLITUDE = '#f4f7f9';
export const FIRE_ENGINE_RED = '#d60f20';
export const ALICE_BLUE = '#f3f8ff';
export const MAIZE = '#f6b65c';
export const SHAMROCK = '#48d3a0';
export const CORAL_PINK = '#fd6e70';
export const GREEN_BRIGHT = '#44c655';
export const MEDIUM_AQUAMARINE = '#51e3ae';
export const LIGHT_GRAY = '#f0f3f6';
export const BEIGE = '#fbe5d6';

export const INPUT_BORDERS_COLOR = 'rgba(0, 0, 0, 0.07)';
export const INPUT_BORDERS_COLOR_ERROR = WATERMELON;

export const SUCCESS_NOTIFICATION_BG = SHAMROCK;
export const ALERT_NOTIFICATION_BG = LIGHT_PINK;
export const PROMO_NOTIFICATION_BG = COBALT;

export const SUCCESS_NOTIFICATION_TEXT_COLOR = WHITE;
export const ALERT_NOTIFICATION_TEXT_COLOR = WATERMELON;
export const PROMO_NOTIFICATION_TEXT_COLOR = WHITE;

export const STARS_FILL_COLOR = '#f6b65c';

export const HIGH_RATING_COLOR = '#44c496';
export const MEDIUM_RATING_COLOR = '#c28e45';
export const LOW_RATING_COLOR = WATERMELON;

export const MAIN_IMAGE_HIGHLIGHT = '#ffd450';

export const ERROR_COLOR = WATERMELON;
export const SUCCESS_COLOR = MEDIUM_AQUAMARINE;
